import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';

Sentry.init({
  dsn: environment.sentryDsn,
  environment: environment.production ? 'production' : 'development',
  integrations: [
    Sentry.browserTracingIntegration({ enableInp: false }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: environment.production ? 0.2 : 0,
  replaysSessionSampleRate: environment.production ? 0.1 : 0,
  replaysOnErrorSampleRate: environment.production ? 1 : 0,
  enableLogs: true,
  sendDefaultPii: false,
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
